import React from "react";
import { Box } from "@mui/material";
import EarningsSearchHero from "../EarningsSearchHero";
import BackButton from "../../../shared/BackButton";

interface SearchTabProps {
  onBack: () => void;
}

const SearchTab: React.FC<SearchTabProps> = ({ onBack }) => {
  return (
    <Box sx={{ position: "relative" }}>
      <BackButton onClick={onBack} />
      <EarningsSearchHero />
    </Box>
  );
};

export default SearchTab;
